// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface String {
  capitalize(): string
}

String.prototype.capitalize = function (): string {
  return this.replace(/\b\w/g, (l) => l.toUpperCase())
}
